import * as _ from 'lodash-es';
import { BlockEmbed } from 'quill/blots/block';
import { Parchment } from 'quill/core';
import React from 'react';
import { createPortal } from 'react-dom';
import { LINK_TYPE_ATTRIBUTE, LINK_TYPES } from '../constants';
import Comment from './Comment';
import Height from './Height';
import * as styles from './IFrame.module.scss';
import Scroll from './Scroll';
import Span from './Span';
import IFrameComponent from '../iframe/IFrameComponent';

class IFrame extends BlockEmbed {
  static shouldLazyLoad = true;

  static create(value: string) {
    const node = super.create(value) as Element;
    node.setAttribute('data-src', value);
    node.setAttribute('contenteditable', 'false');
    node.classList.add(styles.container);

    return node;
  }

  static value(domNode: Element) {
    return domNode.getAttribute('data-src');
  }

  constructor(scroll: Parchment.ScrollBlot, domNode: Element) {
    super(scroll, domNode);
    // @ts-expect-error
    this.id = _.uniqueId();
  }

  attach() {
    super.attach();
    // @ts-expect-error
    this.scroll.emitter.emit(Scroll.events.BLOT_MOUNT, this);
  }

  detach() {
    super.detach();
    // @ts-expect-error
    this.scroll.emitter.emit(Scroll.events.BLOT_UNMOUNT, this);
  }

  html() {
    const src = this.value().iframe;
    return `<a ${LINK_TYPE_ATTRIBUTE}="${LINK_TYPES.iframe}" href=${src}>${src}</a>`;
  }

  format(name: string, value: string) {
    if (
      name === Comment.attrName ||
      name === Span.attrName ||
      name === Height.attrName
    ) {
      const attributor = this.scroll.query(name, Parchment.Scope.ATTRIBUTE);
      if (attributor) {
        // @ts-expect-error
        this.attributes.attribute(attributor, value);
      }
    } else {
      super.format(name, value);
    }
  }

  formats() {
    return this.attributes.values();
  }

  getReferenceNodeForBounds() {
    return this.domNode.querySelector('.iframe-content') || this.domNode;
  }

  renderPortal() {
    const src = this.value().iframe;
    return createPortal(<IFrameComponent src={src} />, this.domNode);
  }
}

IFrame.blotName = 'iframe';
IFrame.className = 'ql-iframe';
IFrame.tagName = 'div';

export default IFrame;
